import { defineMessages } from 'react-intl';

export default defineMessages({
    ctQuoteValidityDays: {
        id: 'quoteandbind.views.pct.quote.Quote Validity Days',
        defaultMessage: 'THIS QUOTE IS VALID FOR {quoteValidityDays} DAYS - COVERAGE IS NOT BOUND UNTIL A BINDER IS ISSUED',
    },
});
